import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BOOK_PAGE, EVENT_TYPES, IMAGES, SEO_META } from '../mock';
import Reveal from '../components/Reveal';
import Booking from '../components/Booking';
import Seo from '../components/Seo';

const ContactPage = () => {
  const { hero } = BOOK_PAGE;

  const scrollToForm = () =>
    document.querySelector('#booking')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <main>
      <Seo {...SEO_META.contact} />
      {/* Hero */}
      <section className="relative overflow-hidden bg-ink pt-20">
        <div className="absolute inset-y-0 right-0 w-full lg:w-[58%]">
          <img
            src={IMAGES.hero}
            alt="Kanwal H. Malik performing"
            className="h-full w-full object-cover object-[65%_center]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/75 to-ink/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-ink/30 lg:hidden" />
        </div>
        <div className="relative z-10 mx-auto max-w-[1400px] px-6 py-16 md:px-10 md:py-24">
          <div className="max-w-xl">
            <Reveal>
              <p className="mb-5 flex items-center gap-4 text-[10px] uppercase tracking-[0.5em] text-gold">
                {hero.label}
                <span className="h-px w-14 bg-gold/50" />
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h1 className="font-serif text-5xl font-light leading-[1.08] tracking-[0.02em] text-white md:text-6xl xl:text-7xl">
                {hero.titleLines[0]}
                <br />
                {hero.titleLines[1]}
              </h1>
            </Reveal>
            <Reveal delay={260}>
              <p className="mt-8 flex flex-wrap items-center gap-y-2 text-[10px] tracking-[0.2em] text-neutral-400">
                {EVENT_TYPES.map((t, i) => (
                  <React.Fragment key={t}>
                    {i > 0 && <span className="mx-3 text-neutral-600">|</span>}
                    <span>{t}s</span>
                  </React.Fragment>
                ))}
              </p>
            </Reveal>
            <Reveal delay={340}>
              <p className="mt-6 font-serif text-lg font-light leading-relaxed text-neutral-300 md:text-xl">
                {hero.text}
              </p>
            </Reveal>
            <Reveal delay={440}>
              <button
                onClick={scrollToForm}
                className="group mt-10 inline-flex items-center gap-3 bg-gold px-7 py-3.5 text-[11px] tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-gold-light"
              >
                {hero.cta}
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Same booking form as homepage */}
      <Booking />
    </main>
  );
};

export default ContactPage;
